import { createContext } from 'react';
export const createQueryDataContext = () => /*#__PURE__*/createContext({
  getCachedQueryState: () => undefined,
  getRefetch: () => () => Promise.resolve({}),
  subscribe: () => ({
    closed: true,
    unsubscribe: () => {}
  })
});